import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/lib/auth-context";
import { apiErr } from "@/lib/api";
import { PasswordInput } from "@/components/ui-bits";

export default function Login() {
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (busy) return;
    setErr(""); setBusy(true);
    try { await signIn(email.trim(), password); navigate("/dashboard"); }
    catch (e) { setErr(apiErr(e?.response?.data?.detail) || "Email or password is incorrect."); setBusy(false); }
  };

  return (
    <div className="auth-screen" data-testid="login-screen">
      <form className="auth-card" onSubmit={submit} data-testid="login-form">
        <img src="/mihp-logo.png" alt="Make It Happen Philly" className="auth-logo" />
        <div className="auth-agency">MAKE IT HAPPEN PHILLY</div>
        <h1 className="auth-title">Staffing Operations</h1>
        <p className="auth-sub">Sign in to the internal MIHP dashboard.</p>
        <label className="auth-lbl">Email
          <input className="auth-input" type="email" inputMode="email" autoComplete="username" value={email}
            onChange={(e) => setEmail(e.target.value)} data-testid="login-email" placeholder="you@makeithappenphilly.org" />
        </label>
        <label className="auth-lbl">Password
          <PasswordInput value={password} onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password" placeholder="••••••••" testid="login-password" />
        </label>
        {err && <div className="auth-err" data-testid="login-error">{err}</div>}
        <button className="auth-btn" type="submit" disabled={busy || !email || !password} data-testid="login-submit">
          {busy ? "Signing in…" : "Sign In"}
        </button>
        <Link to="/forgot-password" className="auth-link" data-testid="login-forgot">Forgot password?</Link>
      </form>
    </div>
  );
}
